import { AgendaService } from './../../Services/agenda.service';
import { Component, OnInit } from '@angular/core';
import { AuthService } from '../../Services/auth.service';
import { IMyDpOptions, IMyMarkedDate, IMyDayLabels } from 'mydatepicker';
import Swal from 'sweetalert2'

@Component({
  selector: 'app-agenda-form',
  template: require('./agenda-form.component.html'),
  styles: [require('./agenda-form.component.css')]
})
export class AgendaFormComponent implements OnInit {
  agendaList: any[] = [];
  agenda: any = {}

  selectedDate: any;
  myDatePickerOptions: IMyDpOptions = {
    todayBtnTxt: 'Vandaag',
    dateFormat: 'dd/mm/yyyy',
    firstDayOfWeek: 'mo',
    sunHighlight: true,
    markCurrentDay: true,
    height: '34px',
    width: '210px',
    alignSelectorRight: false,
    openSelectorTopOfInput: false,
    indicateInvalidDate: true,
    monthSelector: true,
    yearSelector: true,
    minYear: 1920,
    maxYear: 2200,
    componentDisabled: false,
    editableDateField:false,
    showClearDateBtn: true,
    showDecreaseDateBtn: false,
    showIncreaseDateBtn: false,
    showSelectorArrow: true,
    showInputField: true,
    openSelectorOnInputClick: false,
    disableHeaderButtons: true,
    showWeekNumbers: false,
    markDates: [],
    satHighlight: false,
    highlightDates: [],
    markWeekends: <IMyMarkedDate>{},
    monthLabels: {
        1: 'Januari',
        2: 'Februari',
        3: 'Maart',
        4: 'April',
        5: 'Mei',
        6: 'Juni',
        7: 'July',
        8: 'Augustus',
        9: 'September',
        10: 'Oktober',
        11: 'November',
        12: 'December'
    },
    dayLabels: <IMyDayLabels>{
      su: 'zo', mo: 'ma', tu: 'di', we: 'wo', th: 'do', fr: 'vr', sa: 'za'
    },
    allowDeselectDate: true,
    disableWeekdays: [],
    allowSelectionOnlyInCurrentMonth: true
  };

  constructor(private auth: AuthService,
              private agendaService: AgendaService) { }

  ngOnInit() {
    this.getEntireAgenda();
  }

  saveAgenda(){
    this.agenda.date = String(this.selectedDate.date.year)+"-"+String(this.selectedDate.date.month)+"-"+String(this.selectedDate.date.day)
    this.agendaService.create(this.agenda).subscribe( x => {
      // console.log(x);
      this.getEntireAgenda();
    })
  }

  deleteAgenda(id:number){
    Swal.fire({
        title: 'Ben je zeker?',
        text: "Ben je zeker dat je dit agenda item wil verwijderen?",
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Jep',
        cancelButtonText: 'Nope'
      }).then((result) => {
        if (result.value) {
          this.agendaService.delete(id).subscribe( x=> {
            this.getEntireAgenda();
          })
        }
      });
  }

  private getEntireAgenda(){
    this.agendaService.getEntireAgenda().subscribe( x =>{
      this.agendaList = x
      // console.log(this.agendaList)
    })
  }

}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./ClientApp/app/components/agenda-form/agenda-form.component.ts